var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.show)?_c('confirm-notification',{attrs:{"activator":!!_vm.show,"notification":_vm.currentNotification},on:{"close":function($event){_vm.show = false}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }